let count = 0;
function getUniqueId() {
    return `preset::unique-id:${count++}`;
}
export function timedTask(args) {
    return {
        taskId: getUniqueId(),
        type: 'timed',
        ...args,
    };
}
export function staticTask(args) {
    return {
        taskId: getUniqueId(),
        type: 'static',
        ...args,
    };
}
